"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _PreviewDoughnut["default"];
  }
});
var _PreviewDoughnut = _interopRequireDefault(require("./PreviewDoughnut"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }